import EditPartnerDetailFormContainer from './edit-partner-detail-form-container';

export default EditPartnerDetailFormContainer;
